<script setup>
import Header from "@/components/Header.vue";
import {ref, onMounted, onUnmounted} from "vue";

const isScrolled = ref(false);

const props = defineProps({
  paddingHorizontal: {
    type: Number,
    default: 40,
  },
  paddingVertical: {
    type: Number,
    default: 20,
  }
});

const handleScroll = () => {
  isScrolled.value = window.scrollY > 0;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
  <div id="app" class="app-container">
    <Header :is-scrolled="isScrolled" />
    <div class="content" :style="{padding: `${paddingVertical}px ${paddingHorizontal}px`}">
      <slot/>
    </div>
  </div>
</template>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100%;
}

.content {
  flex: 1;
  background-color: #fcfcfd;
}
</style>
